export default {"src":"https://frontends.udemycdn.com/frontends-marketplace-experience/_next/static/media/business.7259f113.svg","height":24,"width":24};